export enum PaymentTabType {
	PAYMENT = 'wplaty',
	PAYOUT = 'wyplaty',
}
